import * as z from "zod";

export const PromoCodeSchema = z.object({
  code: z.string(),
  discount_type: z.string(),
  discount_value: z.number(),
  description: z.string(),
  service_type: z.string().nullable().optional(),
  starts_at: z.string().nullable().optional(),
  expires_at: z.string().nullable().optional(),
});

export const PromoCodeListResponseSchema = z.array(PromoCodeSchema);

export const PromoCodeResponseSchema = PromoCodeSchema;

export const ActivatePromoRequestSchema = z.object({
  code: z.string(),
});

export const DeactivatePromoResponseSchema = z.object({
  success: z.boolean(),
  message: z.string(),
});

